import { Component, OnInit } from '@angular/core'

@Component({
	selector: 'app-error-file-not-found',
	templateUrl: './error-file-not-found.component.html',
	styleUrls: ['./error-file-not-found.component.scss'],
	standalone: false,
})
export class ErrorFileNotFoundComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
